import type { ReactNode } from 'react';
import * as RadixPopover from '@radix-ui/react-popover';
import { content } from './Popover.css';

/** Click-triggered popover with interactive content (unlike Tooltip, which is
 *  hover-only and non-interactive). The trigger is rendered as-is via asChild.
 *  Optionally controlled via `open`/`onOpenChange`; omitting both keeps it uncontrolled. */
export function Popover({ trigger, children, side = 'bottom', align = 'start', open, onOpenChange, contentClassName, contentProps }: {
  trigger: ReactNode;
  children: ReactNode;
  side?: 'top' | 'right' | 'bottom' | 'left';
  align?: 'start' | 'center' | 'end';
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
  contentClassName?: string;
  contentProps?: Record<string, string>;
}) {
  return (
    <RadixPopover.Root open={open} onOpenChange={onOpenChange}>
      <RadixPopover.Trigger asChild>{trigger}</RadixPopover.Trigger>
      <RadixPopover.Portal>
        <RadixPopover.Content className={`${content} ${contentClassName || ''}`} side={side} align={align} sideOffset={8} {...contentProps}>
          {children}
        </RadixPopover.Content>
      </RadixPopover.Portal>
    </RadixPopover.Root>
  );
}
